<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表编号')">
              <j-input :placeholder="$t('请输入表编号')" v-model="queryParam.meterId"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表类型')">
              <a-select v-model="queryParam.mtCode" :placeholder="$t('请选择表类型')">
                <a-select-option v-for="data in userTypeList" :key="data.id" :value="data.id">
                  {{data.mtName}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表口径')">
              <a-select v-model="queryParam.mtCaliber" :placeholder="$t('请选择表口径')">
                <a-select-option v-for="data in userCaliberList" :key="data.mtCaliber" :value="data.mtCaliber">
                  DN{{data.mtCaliber}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('运营商')">
                <j-dict-select-tag v-model="queryParam.mtIotType" :placeholder="$t('请选择运营商')" dictCode="mtIotType" />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('IMEI号')">
                <a-input :placeholder="$t('请输入IMEI号')" v-model="queryParam.mtImei"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('SIM卡号')">
                <a-input :placeholder="$t('请输入SIM卡号')" v-model="queryParam.mtSim"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('册号')">
                <a-input :placeholder="$t('请输入册号')" v-model="queryParam.mtVolumeNo"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('使用状态')">
                <a-select v-model="queryParam.mtState" style="width: 100%" :placeholder="$t('请选择使用状态')">
                  <a-select-option :value="0">
                    {{ $t('未建档') }}
                  </a-select-option>
                  <a-select-option :value="1">
                    {{ $t('已建档') }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('水表用途')">
                <j-dict-select-tag v-model="queryParam.mtUseType" :placeholder="$t('请选择水表用途')" dictCode="mtUseType" />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('是否带阀')">
                <j-dict-select-tag v-model="queryParam.mtHasValve" :placeholder="$t('请选择是否带阀')" dictCode="	yn" />
              </a-form-item>
            </a-col>
            <a-col :xl="12" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('创建时间')">
                <a-range-picker
                  v-model="date"
                  format="YYYY-MM-DD"
                  :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                  @change="onDateRangeChange"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <a-button type="primary" icon="import" @click="showModal">{{ $t('批量导入') }}</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls($t('表具明细'))">{{ $t('导出') }}</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('meterinfo')">导出</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">{{ $t('批量操作') }}<a-icon type="down" /></a-button>
      </a-dropdown>
    </div>
    <div class="flex flex-center" style="margin-bottom: 15px">
      <div class="flex-item" style="height: 80px" v-for="item in totalList" :key="item.key">
        <div class="flex-center" style="height: 100%;background: #e6f7ff;border: 1px solid #91d5ff;flex-direction: column;">
          <div class="flex-center">
            <span class="" style="margin-left:10px;font-size:24px;font-weight: 500">{{item.num}}</span>
            <span class="unit" style="color: #999999">{{item.unit}}</span>
          </div>
          <div class="flex-center" style="color: #999999">{{item.title}}</div>
        </div>
      </div>
    </div>
    <!-- table区域-begin -->
    <div class="table-fixed">
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;" v-if="selectedRowKeys.length > 0">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :components="drag(columns)"
        @change="handleTableChange">
        <span slot="mtStateSlot" slot-scope="text, record">
          <StateNetwork :status="record.mtState"></StateNetwork>
        </span>
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleCycle(record)">{{ $t('全生命周期') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <meterinfo-modal ref="modalForm" @ok="modalFormOk"></meterinfo-modal>
    <meter-import-modal ref="importmodal" @ok="importmodalOK"></meter-import-modal>
    <meter-cycle-modal-list ref="cycleModal" @ok="modalFormOk"></meter-cycle-modal-list>
  </a-card>
</template>
<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import {isUndefined,isEmptyObject} from'@/utils/validate'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import MeterinfoModal from './modules/MeterinfoModal'
  import MeterImportModal from './modules/MeterImportModal'
  import { listSize } from '@/utils/util'
  import { getAction,deleteAction } from '@/api/manage'
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import TableDragResize  from '@/mixins/TableDragResize'
  import JInput from '@/components/jeecg/JInput'
  import MeterCycleModalList from './modules/MeterCycleModalList.vue'

  export default {
    name: 'MeterinfoList',
    mixins:[JeecgListMixin, mixinDevice,TableDragResize],
    components: {
      MeterinfoModal,
      MeterImportModal,
      JInput,
      MeterCycleModalList
    },
    data () {
      return {
        userTypeList:[],  //表类型
        userCaliberList:[],  // 表口径
        description: 'meterinfo管理页面',
        url: {
          list: "/jeecg-charge/meter/meterinfo/list",
          delete: "/jeecg-charge/meter/meterinfo/delete",
          deleteBatch: "/jeecg-charge/meter/meterinfo/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterinfo/exportXls",  //导出接口
          // importExcelUrl: "meter/meterinfo/importExcel",
          userTypeList:"/jeecg-charge/meter/meterType/list",  //表类型请求地址
          userCaliberList:"/jeecg-charge/meter/meterCaliber/list",  //表口径请求地址
          getCount: "/jeecg-charge/meterInspectionRecord/getCount", //获取条目总数
        },
        dictOptions:{},
        dateType: 2,
        totalList: [
          {key: 1,title: this.$t('表总数量'),num: '',unit: this.$t('只')},
          {key: 2,title: this.$t('在库表具数量'),num: '',unit: this.$t('只')},
          {key: 3,title: this.$t('安装数量'),num: '',unit: this.$t('只')},
        ]
      }
    },
    activated() {
      // 只有组件被keep-alive包裹才会触发改方法，由于改页面未使用缓存故将获取跳转参数放置在created中
      console.log("执行activated");
      //获取首页跳转传递的参数
      this.getParams();
    },
    created() {  //入口
      this.getParams()
      this.queryUserTypeList()
      this.queryUserCaliberList()
      console.log("执行creted生命周期")
      this.getTotalCount();
    },
    computed: {
      // importExcelUrl: function(){
      //   return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      // },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: 'rowIndex',
            key:'rowIndex',
            width:60,
            align:"center",
            fixed: 'left',
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            fixed: 'left',
            width: 150
          },{
            title: this.$t('册号'),
            align:"center",
            dataIndex: 'mtVolumeNo',
            width: 150
          },{
            title: this.$t('建档状态'),
            align:"center",
            dataIndex: 'mtState',
            width: 150,
            scopedSlots: { customRender: 'mtStateSlot' },
          },{
            title: this.$t('表类型'),
            align:"center",
            dataIndex: 'mtName',
            width: 100
          },{
            title: this.$t('表口径'),
            align:"center",
            dataIndex: 'mtCaliber',
            customRender: (text,row) => {
              //字典值替换通用方法
              return 'DN'+text;
            },
            width: 80
          },{
            title: this.$t('运营商'),
            align:"center",
            dataIndex: 'mtIotType',
            customRender: (text) => {
              //字典值替换通用方法
              return filterDictTextByCache('mtIotType', text);
            },
            width: 80
          },{
            title: this.$t('水表用途'),
            align:"center",
            dataIndex: 'mtUseType',
            customRender: (text) => {
              //字典值替换通用方法
              return filterDictTextByCache('mtUseType', text);
            },
            width: 80
          },{
            title: this.$t('是否带阀'),
            align:"center",
            dataIndex: 'mtHasValve',
            customRender: (text) => {
              //字典值替换通用方法
              return filterDictTextByCache('yn', text);
            },
            width: 80
          },
          /*
          {
            title:'厂商代码',
            align:"center",
            dataIndex: 'mtComCode',
            width: 100
          },*/
          {
            title: this.$t('水表厂商'),
            align:"center",
            dataIndex: 'mtComName',
            width: 100
          },{
            title: this.$t('IMEI号'),
            align:"center",
            dataIndex: 'mtImei',
            width: 150,
            ellipsis: true,
          },{
            title: this.$t('SIM卡号'),
            align:"center",
            dataIndex: 'mtSim',
            width: 150,
            ellipsis: true,
          },{
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime',
            width: 120,
            ellipsis: true,
          },{
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy',
            width: 120,
            ellipsis: true,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      getTotalCount() {
        getAction(this.url.getCount).then(res => {
          if (res.success) {
            let result = res.result
            for (const key in result) {
              if(key=='meterCount') this.totalList[0].num = result[key];
              if(key=='inStoreroomCount') this.totalList[1].num = result[key];
              if(key=='usageMeterCount') this.totalList[2].num = result[key];
            }
          }
        })
      },
      getParams () {
        let routerParams = JSON.parse(JSON.stringify(this.$route.params));
        if(!isEmptyObject(routerParams)) {
          this.queryParam = this.$options.data.call(this).queryParam
          if(!isUndefined(routerParams.mtCaliber)) {
            this.queryParam.mtCaliber = routerParams.mtCaliber
          }
          if(!isUndefined(routerParams.mtState)) {
            this.queryParam.mtState = routerParams.mtState
          }
          if(!isUndefined(routerParams.mtCode)) {
            this.queryParam.mtCode = routerParams.mtCode
          }
          // this.loadData(1);
          this.searchQuery();
        }
      },
      showModal() {
        this.$refs.importmodal.edit();
        this.$refs.importmodal.title = this.$t("批量导入");
        this.$refs.importmodal.disableSubmit = false;
      },
      importmodalOK(){
        this.loadData();
      },
      initDictConfig(){
      },
      queryUserTypeList() {   //表类型请求
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userTypeList, params).then((res) => {
          if(res.success){
            this.userTypeList = res.result.records;

          }
        }) 
      },
      queryUserCaliberList() {   //表口径请求
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        params.column = 'mtCaliber';
        params.order = 'asc';
        getAction(this.url.userCaliberList, params).then((res) => {
          if(res.success){
            this.userCaliberList = res.result.records;
          }
        }) 
      },
      handleDelete: function (record) {
        if(!this.url.delete){
          this.$message.error(this.$t("请设置url.delete属性!"))
          return
        }
        if(record.mtState!=null&&record.mtState == 1) {
          this.$message.error(this.$t("该表已建档不能删除!"))
          return;
        }
        var that = this;
        deleteAction(that.url.delete, {id: record.id}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      handleCycle(record){
        this.$refs.cycleModal.edit(record);
        this.$refs.cycleModal.title = this.$t("表全生命周期");
        this.$refs.cycleModal.disableSubmit = false;
      }
    }
  }
</script>
<style scoped>
  .table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table{
    border-right: 1px solid #e8e8e8;
  }

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border:1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}

</style>